/* Form Page to create a hospital */
import React, { useState } from "react";
import Form from "react-bootstrap/Form";
import Button from "react-bootstrap/Button";
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";
import Container from "react-bootstrap/Container";
import styles from "../../styles/PostCreateEditForm.module.css"
import appStyles from "../../App.module.css"
import btnStyles from "../../styles/Button.module.css"
import Alert from "react-bootstrap/Alert"

import { useHistory } from "react-router-dom"
import { axiosInstance, axiosReq } from "../../api/axiosDefaults"
import TopBox from "../../components/TopBox"
import { useRedirect } from "../../hooks/Redirect"
import { CLIENT_PROGRAM_HOSTNAME } from "../../utils/config"
import useHostName from "../../hooks/useHostName"
import toast from "react-hot-toast";

const HospitalCreate = () => {
  useRedirect()
  const host = useHostName()
  const [errors, setErrors] = useState({})

  const [postData, setPostData] = useState({
    name: "",
    address_line_1: "",
    address_line_2: "",
    address_line_3: "",
  })

  const {
    name,
    address_line_1,
    address_line_2,
    address_line_3,
  } = postData;

  const history = useHistory()

  const handleChange = (event) => {
    setPostData({
      ...postData,
      [event.target.name]: event.target.value,
    })
  }

  // 1. *** 
  const handleSubmit = async (event) => {
    event.preventDefault()

    // Validate name
    if (!name) {
      toast.error("A Hospital Name Must be Added", {
        duration: 2500,
        position: "top-right",
      });
      return;
    }

    const payload = {
      name,
      address_line_1,
      address_line_2,
      address_line_3,
    };

    try {
      if (host === CLIENT_PROGRAM_HOSTNAME) {
        await axiosReq.post("/masters/hospitals/", payload, {
          headers: { "Content-Type": "application/json" },
        })
        history.push(`/${localStorage.getItem("projectSlug")}/hospitals`)
        toast.success(`Hospital "${name}" Added`);
      } else {
        const response = await axiosInstance.post(
          `${localStorage.getItem("projectSlug")}/masters/hospitals/`,
          payload,
          {
            headers: {
              "Content-Type": "application/json",
              Authorization: `Bearer ${localStorage.getItem("accessToken")}`,
            },
            withCredentials: true,
          }
        )
        if (response?.success === false) {
          throw response.error;
        }
        history.push(`/${localStorage.getItem("projectSlug")}/hospitals`)
        toast.success(`"${name}" Added Successfully!`);
      }
    } catch (err) {
      console.log(err)
      const backendError =
        err?.response?.data?.error ||
        err?.response?.data?.detail ||
        err?.response?.data?.message ||
        "Failed to add hospital.";
      toast.error(backendError)
      if (err.response?.status !== 401) {
        setErrors(err.response?.data || { detail: [backendError] })
      }
    }
  }

  const buttons = (
    <div className="text-center">
      <Button
        className={`${btnStyles.Button} ${btnStyles.Blue} px-3 px-md-5 mr-3`}
        onClick={() => history.goBack()}
      >
        Cancel
      </Button>
      <Button className={`${btnStyles.Button} ${btnStyles.Blue} px-3 px-md-5 ml-3`} type="submit">
        Create
      </Button>
    </div>
  )

  return (
    <div>
      <TopBox title="Add Hospital" />
      <Button
        className={`${btnStyles.Button} ${btnStyles.Blue} text-left my-2`}
        onClick={() => history.goBack()}
      >
        Back
      </Button>
      <Container className= {`px-0 ${appStyles.Content} ${styles.Container} mb-0 pb-0`} >
          <Form className="mt-0 mb-0 pb-0" onSubmit={handleSubmit}>
          <h5 className={`text-center mt-0 mb-4 py-0 ${styles.SubTitle }`}>
          ADD HOSPITAL</h5>
          <div>
          {/* name - address1 */}
          <Row>
          <Col xs={12} md={6} className="d-flex justify-content-center mt-3">
          <Form.Group controlId="name" className={`${styles.Width2} text-center`} >
                  <Form.Label className={`${styles.BoldScene}`}>Name</Form.Label>
                  <Form.Control 
                  type="text"
                  className={styles.Input}
                  name="name"
                  value={name}
                  onChange={handleChange}
                      />
              </Form.Group>
              {errors?.name?.map((message, idx) => (
                <Alert variant="warning" key={idx}>
                  {message}
                </Alert>
              ))}
          </Col>
          <Col xs={12} md={6} className="mt-3 d-flex justify-content-center"  >
              <Form.Group controlId="address_line_1" className={`${styles.Width2} text-center`} >
                      <Form.Label >
                      <p className={`${styles.BoldScene}`}>Address Line 1</p> 
                      </Form.Label>
                      <Form.Control 
                      type="text"
                      className={styles.Input}
                      name="address_line_1"
                      value={address_line_1}
                      onChange={handleChange}
                          />
                  </Form.Group>
                  {errors?.address_line_1?.map((message, idx) => (
                    <Alert variant="warning" key={idx}>
                      {message}
                    </Alert>
                  ))}
          </Col>
          </Row>
          {/* break */}
          <Row>
            <Col xs={12}>
            <hr className={`d-none d-md-block mt-3 mb-3`}/>
            </Col>
          </Row>
          {/* address2 - address 3 */}
          <Row>          
          <Col xs={12} md={6} className="d-flex justify-content-center mt-3"  >
              <Form.Group controlId="address_line_2" className={`${styles.Width2} text-center`} >
                      <Form.Label >
                      <p className={`${styles.BoldScene}`}>Address Line 2</p> 
                      </Form.Label>
                      <Form.Control 
                      className={styles.Input}
                      type="text"
                      name="address_line_2"
                      value={address_line_2}
                      onChange={handleChange}
                          />
                  </Form.Group>
                  {errors?.address_line_2?.map((message, idx) => (
                    <Alert variant="warning" key={idx}>
                      {message}
                    </Alert>
                  ))}
          </Col>
          <Col xs={12} md={6} className="d-flex justify-content-center mt-3"  >
              <Form.Group controlId="address_line_3" className={`${styles.Width2} text-center`} >
                      <Form.Label >
                      <p className={`${styles.BoldScene}`}>Address Line 3</p> 
                      </Form.Label>
                      <Form.Control 
                      className={styles.Input}
                      type="text"
                      name="address_line_3"
                      value={address_line_3}
                      onChange={handleChange}
                          />
                  </Form.Group>
                  {errors?.address_line_3?.map((message, idx) => (
                    <Alert variant="warning" key={idx}>
                      {message}
                    </Alert>
                  ))}
          </Col>
          </Row>
          {/* break */}
          <Row>
            <Col xs={12}>
            <hr className={` mt-3 mb-3`}/>
            </Col>
          </Row>
          </div>
          <Row className="py-3">
            <Col>
            {buttons}
            </Col>
          </Row>
          </Form>
        </Container>
    </div>
  )
}

export default HospitalCreate
